import {
  loadablePage as loadable,
  withDefaultLoaderModifiers,
} from "@gamedev-web/gamedev-sdk-core";

export const PitchWelcomePartnerPage = loadable(() =>
  withDefaultLoaderModifiers(import("./PitchWelcomePartnerPage"))
);
